import type React from 'react';
import type { PhoneInputProps } from 'react-phone-input-2';
import PhoneInput from 'react-phone-input-2';
import ru from 'react-phone-input-2/lang/ru.json';

import cn from 'classnames';

import * as st from './styles.module.scss';

interface Props extends PhoneInputProps {
	label?: string;
	error?: boolean;
}

export const InputPhone: React.FC<Props> = ({ label, error, ...props }) => {
	return (
		<PhoneInput
			placeholder="+7 (000) 000-00-00"
			country={'ru'}
			localization={ru}
			inputClass={cn(st.input, error && st.error)}
			containerClass={cn(st.container, error && st.error)}
			specialLabel={label}
			{...props}
		/>
	);
};
